import { render, staticRenderFns } from "./ProgramEventsTile.vue?vue&type=template&id=63421452&"
import script from "./ProgramEventsTile.vue?vue&type=script&lang=js&"
export * from "./ProgramEventsTile.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEventsTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProgramEventsTile.vue"
export default component.exports